import { render, staticRenderFns } from "./LandingCounters.html?vue&type=template&id=4f0d3a10&scoped=true&"
import script from "./LandingCounters.ts?vue&type=script&lang=ts&"
export * from "./LandingCounters.ts?vue&type=script&lang=ts&"
import style0 from "./LandingCounters.scss?vue&type=style&index=0&id=4f0d3a10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0d3a10",
  null
  
)

export default component.exports